module.exports = __webpack_public_path__ + "./images/6.598a5a07db901cadab9aa3ea50440595.png";